<template>
  <BLayoutView
    :back-route="backRoute"
    :title="pageTitle"
    :skeleton="isLoadingAsyncData"

    hidden-footer
  >
    <template #form>
      <ComponentForm
        v-bind="viewTypeOptions"
        :data="single"
        :skeleton="isLoadingAsyncData"
      />
    </template>
  </BLayoutView>
</template>

<script>
import { createViewMixin } from '@/helpers/mixins/createViewMixin'
import { UsersHistoryModel as Model } from './Model'
import { usersHistoryStoreModule as StoreModule } from './store'
import { USERS_HISTORY_ROUTES as ROUTES } from './utils'

import BLayoutView from '@/components/layouts/BLayoutView.vue'
import ComponentForm from './components/UsersHistoryForm.vue'


const mixinOptions = { Model, StoreModule, ROUTES }
const viewMixin = createViewMixin(mixinOptions)

/** @typedef { import('@/helpers/mixins/createViewMixin').ViewMixin<any, StoreModule> } View */

export default {
  name: 'ViewUsersHistoryView',
  components: {
    BLayoutView,
    ComponentForm,
  },
  mixins: [
    viewMixin,
  ],
  data: () => ({
    backRoute: { name: ROUTES.LIST },
  }),
}
</script>
